import { LogLevel } from '@microsoft/signalr';

export const checkInHubUrl = '/check-in-socket';
export const logLevel = LogLevel.Critical;
